<template>
  <input type="checkbox" v-model="object.selected"/>
</template>

<script>
export default {
  name: 'SelectRowRenderer',
  props: {
    object: {
      type: Object,
    },
  },
  watch: {
    'object.selected': function(isChecked) {
      this.$emit("onSelectRow", this.object)
    }
  }
}
</script>
  